export default function($scope,registerService,$location,ngDialog,$rootScope){
  $scope.user = {name: "", email: "", password: "", password_c: "", phone: "",department: "", company: ""};
  $scope.errors={name:"",email:"",password:"",password_c:"",phone:"",department: "",company:""};

  $scope.isSending = false;

  $scope.register = function () {
    $scope.isSending = !$scope.isSending;//Turn on loading icon.
    $scope.user.email = $scope.user.email.toLowerCase();
    registerService.register($scope.user).success(function() {
      $location.path('/login');
    }).error(function(data){
      console.log(data);
      $scope.isSending = !$scope.isSending;//Turn off loading icon.
      /* When called this functions argument 'data' will be an array of errors.
       * This array holds messages that tell the user where they made a mistake when registering.*/
      $scope.errors.name = data.name;
      if($scope.errors.name){
        $('#name').addClass('has-error');
      }else{
        $('#name').removeClass('has-error');
      }
      $scope.errors.email = data.email;
      if($scope.errors.email){
        $('#email').addClass('has-error');
      }else{
        $('#email').removeClass('has-error');
      }
      $scope.errors.password = data.password;
      if($scope.errors.password){
        $('#password').addClass('has-error');
      }else{
        $('#password').removeClass('has-error');
      }
      $scope.errors.password_c = data.password_c;
      if($scope.errors.password_c){
        $('#password_c').addClass('has-error');
      }else{
        $('#password_c').removeClass('has-error');
      }
      $scope.errors.phone = data.phone;
      if($scope.errors.phone){
        $('#phone').addClass('has-error');
      }else{
        $('#phone').removeClass('has-error');
      }
      $scope.errors.department = data.department;
      if($scope.errors.department){
        $('#department').addClass('has-error');
      }else{
        $('#department').removeClass('has-error');
      }
      $scope.errors.company = data.company;
      if($scope.errors.company){
        $('#company').addClass('has-error');
      }else{
        $('#company').removeClass('has-error');
      }
      $scope.errors.max = data.max;
    });
  };
  $scope.tmpRegister = function () {
    $scope.isSending = !$scope.isSending;//Turn on loading icon.
    $scope.user.email = $scope.user.email.toLowerCase();

    registerService.tmpregister($scope.user).success(function(data) {
      ngDialog.closeAll();
      if(data.msg == "msg"){
        $scope.tmpReg = ngDialog.open({
          templateUrl:'templates/success.tpl.html',
          className:'ngdialog-theme-plain'
        });
        $scope.tmpReg.closePromise.then(function (data) {
          var webBrowser = window.navigator.userAgent.toLowerCase();
          if(webBrowser.indexOf('msie') != -1){
            if(parseInt(webBrowser.split('msie')[1]) == 9){
              location.reload();
            }
          }
        });
      }else if(data.new == "new"){
        $scope.tmpReg = ngDialog.open({
          templateUrl:'templates/new-success.tpl.html',
          className:'ngdialog-theme-plain'
        });
        $scope.tmpReg.closePromise.then(function (data) {
          var webBrowser = window.navigator.userAgent.toLowerCase();
          if(webBrowser.indexOf('msie') != -1){
            if(parseInt(webBrowser.split('msie')[1]) == 9){
              location.reload();
            }
          }
        });
      }else if(data.review == "review-department"){
        $scope.tmpReg = ngDialog.open({
          templateUrl:'templates/review-department.tpl.html',
          className:'ngdialog-theme-plain'
        });
        $scope.tmpReg.closePromise.then(function (data) {
          var webBrowser = window.navigator.userAgent.toLowerCase();
          if(webBrowser.indexOf('msie') != -1){
            if(parseInt(webBrowser.split('msie')[1]) == 9){
              location.reload();
            }
          }
        });
      }else if(data.department == "department"){
        $scope.tmpReg = ngDialog.open({
          templateUrl:'templates/department.tpl.html',
          className:'ngdialog-theme-plain'
        });
        $scope.tmpReg.closePromise.then(function (data) {
          var webBrowser = window.navigator.userAgent.toLowerCase();
          if(webBrowser.indexOf('msie') != -1){
            if(parseInt(webBrowser.split('msie')[1]) == 9){
              location.reload();
            }
          }
        });
      }else if(data.trial == "trial"){
        $scope.tmpReg = ngDialog.open({
            templateUrl:'templates/trial-success.tpl.html',
            className:'ngdialog-theme-plain'
        });
        $scope.tmpReg.closePromise.then(function (data) {
            var webBrowser = window.navigator.userAgent.toLowerCase();
            if(webBrowser.indexOf('msie') != -1){
                if(parseInt(webBrowser.split('msie')[1]) == 9){
                    location.reload();
                }
            }
        });
    }else {
        $scope.tmpReg = ngDialog.open({
            templateUrl:'templates/success.tpl.html',
            className:'ngdialog-theme-plain'
        });
        $scope.tmpReg.closePromise.then(function (data) {
            var webBrowser = window.navigator.userAgent.toLowerCase();
            if(webBrowser.indexOf('msie') != -1){
                if(parseInt(webBrowser.split('msie')[1]) == 9){
                    location.reload();
                }
            }
        });
      }
      //$scope.msg = data.msg;
    }).error(function(data){
      /* When called this functions argument 'data' will be an array of errors.
       * This array holds messages that tell the user where they made a mistake when registering.*/
      $scope.isSending = !$scope.isSending;
      $scope.errors.name = data.name;
      if($scope.errors.name){
        $('#name').addClass('has-error');
      }else{
        $('#name').removeClass('has-error');
      }
      $scope.errors.email = data.email;
      if($scope.errors.email){
        $('#email').addClass('has-error');
      }else{
        $('#email').removeClass('has-error');
      }
      $scope.errors.password = data.password;
      if($scope.errors.password){
        $('#password').addClass('has-error');
      }else{
        $('#password').removeClass('has-error');
      }
      $scope.errors.password_c = data.password_c;
      if($scope.errors.password_c){
        $('#password_c').addClass('has-error');
      }else{
        $('#password_c').removeClass('has-error');
      }
      $scope.errors.phone = data.phone;
      if($scope.errors.phone){
        $('#phone').addClass('has-error');
      }else{
        $('#phone').removeClass('has-error');
      }
      $scope.errors.department = data.department;
      if($scope.errors.department){
        $('#department').addClass('has-error');
      }else{
        $('#department').removeClass('has-error');
      }
      $scope.errors.company = data.company;
      if($scope.errors.company){
        $('#company').addClass('has-error');
      }else{
        $('#company').removeClass('has-error');
      }
    });
  };

  $scope.openTermsOfService = function () {
    window.open(
      `https://www.mapyourproperty.${window.location.host.split('.').pop()}/terms-of-service`,
      '_blank',
    );
  };
};


// WEBPACK FOOTER //
// ./client/controllers/Register.js